module.exports = __webpack_public_path__ + "img/cend1_zh.e88db30.png";